/** Substantive editorial copy for /book-experiences — indexed for AdSense quality review. */

export const BOOKING_EDITORIAL_SECTIONS = [
	{
		id: 'why-book',
		title: 'Why book through Visit All Nepal?',
		paragraphs: [
			'Nepal has thousands of trekking agencies, guesthouses, and transport operators — quality varies enormously. Visit All Nepal acts as your single point of contact: you pay a small deposit online, we assign a verified local operator matched to your route and dates, and our team stays available before and during your trip.',
			'We publish the same step-by-step journey guides you read on this site — visa checklists, permit requirements, packing lists, and day-by-day trek planners — so you know exactly what you are booking before you commit. Booking is optional; the travel content is free and always will be.',
		],
	},
	{
		id: 'group-departures',
		title: 'Joining a group departure',
		paragraphs: [
			'Group departures are fixed-date treks and tours where solo travelers, couples, and friends share costs with others on the same itinerary. You choose a published departure month, pay a deposit to reserve your seat, and we confirm the operator, guide, and inclusions before you travel.',
			'This is the most popular way to trek Everest Base Camp, Annapurna Base Camp, and Langtang Valley when you do not want to organize permits, flights to Lukla, or teahouse logistics yourself. Group sizes are kept small; you walk with people who chose the same dates, not a random bus tour.',
		],
		links: [
			{ to: '/group-trips', label: 'Browse group departures' },
			{ to: '/journeys/everest-base-camp', label: 'Everest Base Camp journey planner' },
		],
	},
	{
		id: 'private-tours',
		title: 'Private tours on your dates',
		paragraphs: [
			'Private tours suit travelers who want their own guide, flexible pacing, or a custom route — honeymoons, families, photographers, or anyone who prefers not to share a group. Tell us your dates, fitness level, and must-see places; we return a quote with a clear breakdown of what is included.',
			'Private does not mean expensive for every route. A four-day Poon Hill trek for two people can cost less than you expect when split between travelers. Longer restricted-area treks (Upper Mustang, Manaslu) require agency permits anyway — private is often the only practical option.',
		],
		links: [{ to: '/packages', label: 'Request a private tour quote' }],
	},
	{
		id: 'shared-rides',
		title: 'Shared intercity transport',
		paragraphs: [
			'Shared rides cover popular overland routes — Kathmandu to Pokhara, Pokhara to Chitwan, Kathmandu to Syabrubesi for Langtang — where a seat in a tourist jeep or bus is cheaper than a private hire. You reserve online, meet at the departure point, and travel with other passengers on a scheduled run.',
			'This is budget transport, not a sightseeing tour. If you want stops at viewpoints or a flexible schedule, choose a private tour instead. Shared rides are best when you know your date and just need reliable wheels between cities.',
		],
		links: [{ to: '/shared-rentals', label: 'Book shared transport' }],
	},
	{
		id: 'before-you-pay',
		title: 'What happens after you pay a deposit',
		paragraphs: [
			'Your deposit secures your place — on a group departure seat, a private tour quote acceptance, or a shared ride reservation. We confirm availability with the assigned operator within one to two business days. You receive contact details, a summary of inclusions, and any documents you need before arrival in Nepal.',
			'Final balances are typically due before departure or on arrival, depending on the product. Cancellation terms are shown at checkout. If a group departure does not reach minimum numbers, we offer an alternative date or a full deposit refund — we do not silently cancel without telling you.',
		],
	},
	{
		id: 'plan-first',
		title: 'Plan first, book when ready',
		paragraphs: [
			'Most visitors spend weeks reading about visa rules, choosing between EBC and ABC, and checking festival dates before booking anything. Use our free guides — visa on arrival, TIMS permits, best season, teahouse trekking expectations — then book when your dates and route are decided.',
		],
		links: [
			{ to: '/guides', label: 'All travel guides' },
			{ to: '/visa', label: 'Visa & arrival hub' },
			{ to: '/trekking', label: 'Trekking hub' },
			{ to: '/journeys', label: 'Guided journey planners' },
		],
	},
];
